'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var TimeDelayTrigger = new _immutable.Record({
  enabled: false,
  timeDelaySeconds: 0
}, 'TimeDelayTrigger');

exports.default = TimeDelayTrigger;
module.exports = exports['default'];